module.exports = __webpack_public_path__ + "media/home/employee-handshake-633b969d.jpg";